"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platforms = void 0;
var platforms = {
    MarketingSite: 'MarketingSite',
    PartnerLibrary: 'PartnerLibrary',
    LegalTexts: 'LegalTexts',
    EventPortal: 'EventPortal',
    Hints: 'Hints',
};
exports.platforms = platforms;
